module.exports = __webpack_public_path__ + "static/media/background.6ddf7ddd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.webp
// module id = 133
// module chunks = 0